import { theme } from '@fiverr-private/theme';

/**
 * The base class for the toast tray container.
 */
export const BASE_CLASS = 'toaster-container';

/**
 * Builds the container className by location
 */
export const buildContainerClass = (location: string) => `${BASE_CLASS}-${location}`;

/**
 * The base styles for the toasts' container.
 */
export const BASE_STYLE = {
    position: 'fixed',
    zIndex: theme.zIndex.toast,
};

/**
 * The base styles for all centered toasts' containers.
 */
export const CENTER_CONTAINERS_STYLE = {
    left: '50%',
    transform: 'translateX(-50%)',
};
